'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useState } from 'react';
import { useConfig } from '@/config';
import { init, push } from '@/util/matomo';
const DISABLE_ANALYTICS_COOKIE_NAME = 'disable_analytics';
const hasDisableCookie = () => typeof document !== 'undefined' && document.cookie.includes(`${DISABLE_ANALYTICS_COOKIE_NAME}=1`);
function Matomo() {
  const $ = _c(18);
  const config = useConfig();
  const {
    MATOMO_URL,
    MATOMO_CDN_URL,
    MATOMO_SITE_ID
  } = config;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const [initialized, setInitialized] = useState(false);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.toString();
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParamsString = t0;
  let t1;
  if ($[2] !== MATOMO_CDN_URL || $[3] !== MATOMO_SITE_ID || $[4] !== MATOMO_URL) {
    t1 = hasDisableCookie() || !MATOMO_URL || !MATOMO_SITE_ID || !MATOMO_CDN_URL;
    $[2] = MATOMO_CDN_URL;
    $[3] = MATOMO_SITE_ID;
    $[4] = MATOMO_URL;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const isAnalyticsDisabled = t1;
  let t2;
  let t3;
  if ($[6] !== MATOMO_CDN_URL || $[7] !== MATOMO_SITE_ID || $[8] !== MATOMO_URL || $[9] !== initialized || $[10] !== isAnalyticsDisabled) {
    t2 = () => {
      if (isAnalyticsDisabled || initialized) {
        return;
      }
      init({
        url: MATOMO_URL,
        cdnUrl: MATOMO_CDN_URL,
        siteId: MATOMO_SITE_ID,
        disableCookies: true
      });
      return () => {
        setInitialized(true);
      };
    };
    t3 = [initialized, MATOMO_URL, MATOMO_CDN_URL, MATOMO_SITE_ID, isAnalyticsDisabled];
    $[6] = MATOMO_CDN_URL;
    $[7] = MATOMO_SITE_ID;
    $[8] = MATOMO_URL;
    $[9] = initialized;
    $[10] = isAnalyticsDisabled;
    $[11] = t2;
    $[12] = t3;
  } else {
    t2 = $[11];
    t3 = $[12];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[13] !== isAnalyticsDisabled || $[14] !== pathname || $[15] !== searchParamsString) {
    t4 = () => {
      if (isAnalyticsDisabled || !pathname) {
        return;
      }
      const url = `${pathname}${searchParamsString ? "?" + decodeURIComponent(searchParamsString) : ""}`;
      push(["setCustomUrl", url]);
      push(["trackPageView"]);
    };
    t5 = [pathname, searchParamsString, isAnalyticsDisabled];
    $[13] = isAnalyticsDisabled;
    $[14] = pathname;
    $[15] = searchParamsString;
    $[16] = t4;
    $[17] = t5;
  } else {
    t4 = $[16];
    t5 = $[17];
  }
  useEffect(t4, t5);
  return null;
}
export default function MatomoAnalyticsConsent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense><Matomo /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}